import Quill from 'quill';
import { attachMathfieldKeyboardListeners } from './math-field-keyboard';
const BlockEmbed = Quill.import('blots/embed');

// Define the custom Input Blot class
export class MathFieldBlot extends BlockEmbed {
  static blotName = 'input';
  static tagName = 'span';
  static className = 'mf-blot';
  static create(value) {
    const node = super.create();
    
    // Create an input element
    const mathField:any = document.createElement('math-field');

    mathField.style.minWidth = value.width || '150px';
    mathField.style.display = 'inline-block';
    // Set content if available
    if (value.content) {
      mathField.innerHTML = value.content;
    }
    
    // Make it contenteditable
    mathField.setAttribute('contenteditable', 'true');
    mathField.setAttribute('tabindex', '0');
    mathField.setAttribute('virtual-keyboard-target-origin', '*');
    // mathField.setAttribute('math-virtual-keyboard-policy', 'manual');
    mathField.mathVirtualKeyboardPolicy = "manual";
    // Add event listeners to ensure model updates
    mathField.addEventListener('input', (event) => {
      mathField.innerHTML = mathField.value;
    });
    const containerHeight = value.pageHeight ?? (document.querySelector('.page-container') as HTMLElement).style?.height;
    //this.keyboardOpen = value.keyboardOpen;

    attachMathfieldKeyboardListeners({
      mathField: mathField,
      keyboard: (window as any).mathVirtualKeyboard,
      isOpen: () => this.keyboardOpen,
      setOpen: v => this.keyboardOpen = v,
      //updateLayout: () => this.updateMathFieldKeyboard(),
      pageContainerSelector: '.page-container',
      pageOriginalHeight: containerHeight
    });
    // Append the math field to our blot node
    
    node.classList.add(this.className);
    node.appendChild(mathField);
    // Auto focus the newly created math field
    //setTimeout(() => mathField.focus(), 0);
   
    return node;
  }

  static value(node) {
    const mathField = node.querySelector('math-field');
    return {
      content: mathField ? mathField.innerHTML : '',
      width: mathField ? mathField.style.minWidth : '150px'
    };
  }
}